import { WORKFLOW_UI_IDENTIFIER } from '@app-store'
import { TASK_TYPE_CONSTANTS } from './constants'

const INBOUND_TASK_TEMPLATES = [
  TASK_TYPE_CONSTANTS.FAX_INBOUND,
  TASK_TYPE_CONSTANTS.MAIL_INBOUND,
  TASK_TYPE_CONSTANTS.WEB_INBOUND,
] as const

const normalizeTemplateName = (name?: string) =>
  name?.toLowerCase().replace(/[\s-_]/g, '') ?? ''

export const isInboundChannelTaskTemplate = (taskTemplateName?: string) => {
  const normalized = normalizeTemplateName(taskTemplateName)
  return INBOUND_TASK_TEMPLATES.some(
    (template) => normalizeTemplateName(template) === normalized
  )
}

export const getInboundUiIdentifierForTemplate = (
  taskTemplateName?: string
): string => {
  const normalized = normalizeTemplateName(taskTemplateName)
  if (normalized === normalizeTemplateName(TASK_TYPE_CONSTANTS.MAIL_INBOUND)) {
    return WORKFLOW_UI_IDENTIFIER.MAIL_INBOUND_TASK
  }
  if (normalized === normalizeTemplateName(TASK_TYPE_CONSTANTS.WEB_INBOUND)) {
    return WORKFLOW_UI_IDENTIFIER.WEB_INBOUND_TASK
  }
  return WORKFLOW_UI_IDENTIFIER.FAX_INBOUND_TASK
}

export const isInboundChannelUiIdentifier = (uiIdentifier?: string) =>
  uiIdentifier === WORKFLOW_UI_IDENTIFIER.FAX_INBOUND_TASK ||
  uiIdentifier === WORKFLOW_UI_IDENTIFIER.MAIL_INBOUND_TASK ||
  uiIdentifier === WORKFLOW_UI_IDENTIFIER.WEB_INBOUND_TASK
